export default __webpack_public_path__ + "static/media/sent.62983115.svg";